const storageKey = 'google_translate_target_lang'
const ApiKey = 'AIzaSyCo8ThKjYkFgzj45lpp5PQuF8R0ffHhQJQ'
const translateEndpoint = 'https://translation.googleapis.com/language/translate/v2?key=' + ApiKey
import axios from 'axios'
import { languages } from '../plugins/languageList'
import marked from 'marked/lib/marked'

function translateLanguageCode(languages, code) {
  let language = languages.find((item) => item.lang === code)
  if (!language) console.info(code + ' language code is not found in google supported languages')
  return language
}

export default {
  namespaced: true,

  state: {
    show_translations: false,
    // translated question and choices
    question_title: null,
    choice_titles: null,
    target_language: null,
    languages
  },

  mutations: {
    SET_TARGET_LANGUAGE(state, language) {
      state.target_language = language
    },
    SET_QUESTION_TITLE(state, title) {
      state.question_title = title
    },
    SET_CHOICE_TITLES(state, titles) {
      state.choice_titles = titles
    },
    SET_SHOW_TRANSLATIONS(state, load) {
      state.show_translations = load
    }
  },

  getters: {
    translatedQuestion(state) {
      if (state.show_translations) {
        return state.question_title.translatedText
      }
    },
    translatedChoice(state) {
      if (state.show_translations) {
        return function(index) {
          console.log('index')
          console.log(index)
          console.log('state.choice_titles')
          console.log(state.choice_titles)
          return state.choice_titles[index].translatedText
        }
      }
    }
  },

  actions: {
    // get current questions and its choices
    // translate via google api
    async translate({ commit, state, rootState }, questionIndex) {
      let currentQuestion = rootState.exam.questions[questionIndex]
      let sourceLang = rootState.language.selected_language.lang
      let targetLang = state.target_language.lang
      let problem_title = currentQuestion.problem_title
      let choice_titles = []
      currentQuestion.choices.forEach((choice) => {
        choice_titles.push(choice.choice_title)
      })

      console.log('choice_titles to be translated')
      console.log(choice_titles)

      console.log('problem_title to be translated')
      console.log(problem_title)

      let query = `${translateEndpoint}&source=${sourceLang}&target=${targetLang}`
      query += `&q=${encodeURIComponent(marked(problem_title))}`
      choice_titles.forEach((choice_title) => {
        query += `&q=${encodeURIComponent(marked(choice_title))}`
      })

      let { data } = await axios.get(query)

      console.log('data.data.translations')
      console.log(data.data.translations)

      let problem_trans = data.data.translations[0]
      let choices_trans = data.data.translations.slice(1)

      // console.log('data.data.translations.shift()')
      // console.log(data.data.translations.shift())

      commit('SET_QUESTION_TITLE', problem_trans)
      commit('SET_CHOICE_TITLES', choices_trans)
      commit('SET_SHOW_TRANSLATIONS', true)
    },
    updateTargetLanguage({ commit, state }, lang) {
      let language = translateLanguageCode(state.languages, lang)
      if (language) {
        localStorage.setItem(storageKey, lang)
        commit('SET_TARGET_LANGUAGE', language)
      }
    },
    initTargetLanguage({ commit, state, dispatch }) {
      dispatch('clear')
      let lang = localStorage.getItem(storageKey)
      let language = translateLanguageCode(state.languages, lang)
      if (!language) {
        language = state.languages[0]
      }

      commit('SET_TARGET_LANGUAGE', language)
    },

    clear({ commit }) {
      commit('SET_SHOW_TRANSLATIONS', false)
      commit('SET_QUESTION_TITLE', null)
      commit('SET_CHOICE_TITLES', null)
    }
  }
}
